import { render, staticRenderFns } from "./NetworkReport.vue?vue&type=template&id=20f68b9e"
import script from "./NetworkReport.vue?vue&type=script&lang=js"
export * from "./NetworkReport.vue?vue&type=script&lang=js"
import style0 from "./NetworkReport.vue?vue&type=style&index=0&id=20f68b9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports